// Hotbar HUD (UI-4): 9 slots backed by the player inventory's hotbar range, with
// the selected column highlighted and item icons + counts. Elements are built
// once and only touched when a slot's contents change (no per-frame DOM churn —
// re-setting a data-URI background each frame forces an image decode). Client
// only (ENG-1).
import { h } from '../h';
import { isEmpty } from '../../../sim/game/inventory';
import type { Game } from '../../boot';

export class Hotbar {
  readonly el: HTMLElement;
  private readonly cells: HTMLElement[] = [];
  private readonly icons: HTMLElement[] = [];
  private readonly counts: HTMLElement[] = [];
  private readonly last: string[] = new Array(9).fill('');
  private lastSel = -1;
  private lastHidden: boolean | null = null;

  constructor() {
    this.el = h('div', { class: 'bb-hotbar' });
    for (let i = 0; i < 9; i++) {
      const icon = h('div', { class: 'bb-slot-icon' });
      const count = h('span', { class: 'bb-slot-count' });
      const cell = h('div', { class: 'bb-hotbar-slot' }, icon, count);
      this.icons.push(icon);
      this.counts.push(count);
      this.cells.push(cell);
      this.el.append(cell);
    }
  }

  update(game: Game): void {
    const hidden = game.playerState.gameMode === 'spectator';
    if (hidden !== this.lastHidden) { this.el.style.display = hidden ? 'none' : 'flex'; this.lastHidden = hidden; }
    if (hidden) return;
    const pinv = game.playerState.inventory;
    if (pinv.selected !== this.lastSel) {
      this.cells[this.lastSel]?.classList.remove('sel');
      this.cells[pinv.selected]?.classList.add('sel');
      this.lastSel = pinv.selected;
    }
    for (let i = 0; i < 9; i++) {
      const s = pinv.get(i);
      // The icon revision is part of the key: editing a texture changes neither
      // the item nor the count, so without it an authored icon never repaints.
      const key = isEmpty(s) ? '' : `${s.item}:${s.count}:${game.icons.revision}`;
      if (key === this.last[i]) continue;
      this.last[i] = key;
      if (isEmpty(s)) {
        this.icons[i]!.style.backgroundImage = '';
        this.counts[i]!.textContent = '';
      } else {
        this.icons[i]!.style.backgroundImage = `url(${game.icons.get(s.item)})`;
        this.counts[i]!.textContent = s.count > 1 ? String(s.count) : '';
      }
    }
  }
}
